export const challengeGrowthTemplate = {
  id: 'challengeGrowth',
  title: 'Challenge & Growth',
  description: 'For prompts about overcoming obstacles, learning from failure, or demonstrating resilience and adaptability',
  wordTarget: 250,
  sections: [
    {
      id: 'the_moment',
      label: 'The Moment',
      type: 'opening',
      prompt: 'Describe the specific situation or challenge. Put us there — what happened, where were you, what did it feel like?',
      coachVoice: "Resist the urge to start with the lesson. Start with the mess. The best challenge essays drop the reader into the difficulty before explaining the resolution. Also: the challenge doesn't need to be dramatic. A genuine struggle with self-doubt, a project that fell apart, or a difficult conversation can be more compelling than a tragedy.",
      sample: "I stood in front of my robotics team holding a circuit board that had taken three weeks to design, and it was completely wrong. Not wrong in a fixable way — wrong in a 'we need to start over with four days until competition' way. Everyone was looking at me because I'd insisted on this design.",
      minWords: 50,
      unlockWords: 25
    },
    {
      id: 'why_it_mattered',
      label: 'Why It Mattered',
      type: 'stakes',
      prompt: 'Why was this challenge significant to you? What was at stake beyond the obvious?',
      coachVoice: "Go one layer deeper. If the project failed, the surface stake was the competition. But the real stake might have been your confidence as a leader, your relationship with the team, or your belief in your own technical abilities. Name the real stakes.",
      sample: "The circuit board failure wasn't just about the competition. It was the first time I'd taken full ownership of a technical decision, overriding suggestions from teammates who had more experience. If my design failed — which it had — it meant my confidence had outpaced my competence, and everyone knew it.",
      minWords: 50,
      unlockWords: 25
    },
    {
      id: 'how_you_responded',
      label: 'How You Responded',
      type: 'approach',
      prompt: 'What did you actually do? Not what you felt — what actions did you take?',
      coachVoice: "Show your process, not just the outcome. Did you ask for help? Change your approach? Have an honest conversation? The actions you took reveal your character more than the result. And if you made mistakes along the way, include those — perfect responses aren't believable.",
      sample: "I called an emergency team meeting and did the hardest thing: I admitted the design was my fault and asked for help. Sarah, whose approach I'd overruled, pulled out her original sketches. Instead of saying 'I told you so,' she said 'Let's combine the best parts of both.' We rebuilt the board in 72 hours, splitting shifts, and it worked — not because of my design or hers, but because we stopped competing and started collaborating.",
      minWords: 60,
      unlockWords: 30
    },
    {
      id: 'what_changed',
      label: 'What Changed',
      type: 'growth',
      prompt: 'How did this experience change how you approach problems, lead, or think about yourself?',
      coachVoice: "The growth should feel earned, not performed. Don't claim you 'learned the value of teamwork' — show how your actual behavior changed in a specific later situation. Concrete evidence of change is more convincing than abstract reflection.",
      sample: "Now when I lead a project, my first move is to build in a 'challenge round' — I present my approach and specifically ask the team to find its weaknesses before we commit. It feels counterintuitive to invite criticism of your own ideas, but I've learned that the discomfort of being questioned early is nothing compared to the cost of being wrong late.",
      minWords: 50,
      unlockWords: 25
    }
  ]
};
